export default __webpack_public_path__ + "e9ae53f0aaf62af9624cc4ca33490f62.svg";